import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-quick-upload',
  templateUrl: './quick-upload.component.html',
  styleUrls: ['./quick-upload.component.scss']
})
export class QuickUploadComponent {
  @Input() disabled: boolean = false;
  @Input() records: any[] = [];
  @Input() recordsLabel: string = '';
  @Input() inputId: string = 'qupload';

  @Output() fileSelected = new EventEmitter<any[]>();
  @Output() cleared = new EventEmitter<void>();
  @Output() viewRecords = new EventEmitter<void>();
  @Output() downloadTemplate = new EventEmitter<void>();

  get validRecords(): any[] {
    if (!this.records || !Array.isArray(this.records)) { return []; }
    return this.records.filter(r => r !== null && r !== undefined && r !== '');
  }

  triggerUpload() {
    const el = document.getElementById(this.inputId);
    if (el) {
      el.click();
    }
  }

  onFileChange(eve: any) {
    const target = eve.target;
    if (!target.files || target.files.length === 0) {
      return;
    }
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      const wb: XLSX.WorkBook = XLSX.read(e.target.result, { type: 'binary' });
      const ws: XLSX.WorkSheet = wb.Sheets[wb.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(ws);
      target.value = '';
      this.fileSelected.emit(rows as any[]);
    };
  }
}
